// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MediaSvg from '@rsuite/icon-font/lib/av/Media';
var Media = createSvgIcon({
  as: MediaSvg,
  ariaLabel: 'media',
  category: 'av',
  displayName: 'Media'
});
export default Media;